import { Component, OnInit } from '@angular/core';
import { ChildrenOutletContexts, NavigationEnd, Router, RouterModule } from '@angular/router';
import { Helpers } from '../../helpers/helpers';
import { TrackingService } from '../../services/tracking.service';
import { LogType } from '../../enums/logtype';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MktCoopFilterService } from '../../services/mkt-coop-filter.service';
import { MktCoopActionFilters } from '../../models/mkt-coop-action';


@Component({
  templateUrl: './default-layout.component.html'
})

export class DefaultLayoutComponent implements OnInit {

  private unsubscribe$ = new Subject<void>();

  constructor(
    private router: Router,
    private trackingService: TrackingService,
    private filterService: MktCoopFilterService,
    public helper: Helpers
  ) {

  }

  ngOnInit() {
    this.router.events.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        this.trackUser(LogType.Nav);
        if (!this.router.url.includes('mkt-coop'))
          this.filterService.filter = new MktCoopActionFilters();
      }
    });
  }

  trackUser(idLogType) {
    this.trackingService.trackUser({ IdLogType: idLogType, Url: this.router.url }).subscribe();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}

